export const ENREGISTRE = 'Enregistre';
export const ENVOYE = 'Envoye';

export const ETAT_RELANCES = [
  { etat: ENREGISTRE, libelle: 'relance.etat.enregistre' },
  { etat: ENVOYE, libelle: 'relance.etat.envoye' },
];
export const NIVEAU_RELANCES = [
  { code: 1, libelle: 'relance.niveauRelance.niveau1' },
  { code: 2, libelle: 'relance.niveauRelance.niveau2' },
  { code: 3, libelle: 'relance.niveauRelance.niveau3' },
];

export const ACTION_RELANCER = 'relancer';
export const ACTION_ENVOYER_PAR_MAIL = 'envoyerParMail';

export const TYPE_EDITION_RELANCE = 'Relance';

export const TYPE_EDITION_RELANCE_MAIL = 'relance';

export const EXPORT_EXCEL_RELANCE = 'relancesSave';

export const GET_LAST_PAY_LOAD = 'true';
